import {Component} from 'react'
import PropTypes from 'prop-types'
import InputRange from "./components/InputRange.jsx"
import './FilterDistance.scss'

export default class FilterDistance extends Component {
  static propTypes = {
    distance: PropTypes.string,
    className: PropTypes.string,
    onChange: PropTypes.func.isRequired,
  }

  static defaultProps = {
    distance: '40',
    className: '',
  }

  onDistanceChange = (value) => {
    this.props.onChange({
      distance: value,
    })
  }

  render() {
    return <div className="filter-distance-form">
      <label>Km autour de la ville</label>
      <InputRange defaultValue={this.props.distance} onChange={this.onDistanceChange} />
    </div>
  }
}
